import { scaleLinear } from 'd3';
import * as chroma from 'chroma-js';

export function idxToDate(i) {
	let days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
	let date = new Date(2020, 2, 28);
	date.setHours(date.getHours() + 8 * (i-1));
	let dateString = "";
	dateString += days[date.getDay()] + " ";
	date.setHours(date.getHours() + 8);
	dateString += date.getDate() + "/";
	dateString += date.getMonth()+1
	return dateString
}

export function idxToFilename(i) {
	let baseFileame = 'Denmark_'; // 2020_03_28 0000
	let date = new Date(2020, 2, 28);
	date.setHours(date.getHours() + 8 * i);
	let filenameAppendix = ""
	filenameAppendix += date.getFullYear() + "_";
	filenameAppendix += pad(date.getMonth()+1) + "_"
	filenameAppendix += pad(date.getDate()) + "_";
	filenameAppendix += pad(date.getHours()) + "00";
	let filename = baseFileame + filenameAppendix + ".json";
	return filename
}

function pad(d) {
	if (d.toString().length == 1) {
		return "0" + d;
	} else {
		return d;
	}
}

export function getTooltip({object}) {
	return object && `Muni.: ${object.properties.ko}

		On date: ${round(object.properties.lo, 1e0)}
		Baseline: ${round(object.properties.bl, 1e0)}
		Deviation: ${round(object.properties.gr * 100, 1e1)}%`;
};

export function cmap(x, scheme) {
	let scaler = scaleLinear()
		.domain([-1, 1])
		.range([0, 1])
	let scale = chroma.default.scale(scheme)
	return scale(scaler(x)).rgb()
}

function round(value, precision) {
	return Math.round(value*precision)/precision;
}